import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

const CongressionalOutreachSubpageLinks: FunctionComponent<{
  currentSlug: string;
  linksList: { urlSlug: string; linkText: string }[];
}> = ({ currentSlug, linksList }) => {
  return (
    <ul>
      {linksList.map((image, index) =>
        currentSlug !== image.urlSlug ? (
          <li key={index}>
            <Link to={image.urlSlug}>{image.linkText}</Link>
          </li>
        ) : null
      )}
      <li>
        <Link to={`/faq/congressional_outreach`}>Frequently Asked Questions</Link>
      </li>
    </ul>
  );
};

export default CongressionalOutreachSubpageLinks;
